import React, { useEffect, useState, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { SocialProofStrip } from './components/SocialProofStrip';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatIncludesSection } from './components/WhatIncludesSection';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { PurchaseSection } from './components/PurchaseSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { useLocalCurrency } from './hooks/useLocalCurrency';
// Meta Pixel helper
const PIXEL_IDS = ['3070568583125644', '713766391617609', '1225428543097695'];
function initMetaPixel() {
  if (typeof window === 'undefined') return;
  if ((window as any).fbq) return; // already initialized
  const f: any = function (...args: any[]) {
    f.callMethod ? f.callMethod.apply(f, args) : f.queue.push(args);
  };
  f.push = f;
  f.loaded = true;
  f.version = '2.0';
  f.queue = [] as any[];
  (window as any).fbq = f;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
  // Initialize both pixels
  PIXEL_IDS.forEach(id => {
    ;
    (window as any).fbq('init', id);
  });
  (window as any).fbq('track', 'PageView');
}
function trackEvent(eventName: string) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', eventName);
  }
}
export function App() {
  const [showStickyCta, setShowStickyCta] = useState(false);
  const {
    formatPriceCompact
  } = useLocalCurrency();
  useEffect(() => {
    // Initialize Meta Pixel via direct script injection
    try {
      initMetaPixel();
    } catch (e) {
      console.warn('Meta Pixel initialization failed:', e);
    }
    // Track checkout clicks
    const handleCheckoutClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('a[href*="hotmart.com"]')) {
        trackEvent('InitiateCheckout');
      }
    };
    document.addEventListener('click', handleCheckoutClick);
    return () => document.removeEventListener('click', handleCheckoutClick);
  }, []);
  // Show sticky CTA only after user reaches the purchase/checkout section
  useEffect(() => {
    const purchaseSection = document.getElementById('compra');
    if (!purchaseSection) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show sticky when the purchase section enters the viewport
      setShowStickyCta(entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(purchaseSection);
    return () => observer.disconnect();
  }, []);
  return <div className="min-h-screen bg-[#0C2818] font-sans text-gray-100 overflow-x-hidden" data-id="element-0">
      <CountdownBar data-id="element-1" />

      <main className="pt-[48px] md:pt-[52px]" data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProofStrip data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <EmotionalTransition data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <WhatIncludesSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <UrgencySection data-id="element-10" />
        <PurchaseSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection data-id="element-14" />
      </main>

      {/* Sticky Mobile CTA - only visible after scrolling past hero CTA */}
      <div className={`fixed bottom-0 left-0 w-full z-40 md:hidden bg-[#143524] border-t-2 border-[#FBBF24] shadow-[0_-4px_20px_rgba(0,0,0,0.5)] p-3 transition-transform duration-300 ${showStickyCta ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-15">
        <a href="https://pay.hotmart.com/J104331849I?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full bg-[#16A34A] text-white font-black text-lg py-3 rounded-xl flex items-center justify-center gap-2 shadow-lg" data-id="element-16">
          👉 ¡QUIERO MI MEGAPACK!
          <span className="text-[#FBBF24] text-sm font-bold" data-id="element-17">
            {formatPriceCompact(13.99)}
          </span>
        </a>
      </div>

      <footer className="bg-[#0C2818] text-gray-500 py-8 pb-24 md:pb-8 text-center text-sm border-t border-[#1E4D2B]" data-id="element-18">
        <div className="max-w-7xl mx-auto px-4" data-id="element-19">
          <p className="mb-2" data-id="element-20">
            © {new Date().getFullYear()} MegaPack Educación Física LISTA™.
            Todos los derechos reservados.
          </p>
          <p data-id="element-21">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
          <div className="mt-4 text-xs text-gray-600 flex flex-wrap justify-center gap-2" data-id="element-22">
            <span className="hover:text-gray-400 cursor-pointer transition-colors" data-id="element-23">
              Política de Privacidad
            </span>
            <span data-id="element-24">|</span>
            <span className="hover:text-gray-400 cursor-pointer transition-colors" data-id="element-25">
              Términos y Condiciones
            </span>
            <span data-id="element-26">|</span>
            <span className="hover:text-gray-400 cursor-pointer transition-colors" data-id="element-27">
              Contacto
            </span>
          </div>
        </div>
      </footer>

      <SocialProofPopup data-id="element-28" />
    </div>;
}